(() => {
  const TARGET_METAFIELD = "custom.size_chart";
  const MODAL_SELECTOR = `modal-dialog.product-popup-modal[data-metafield="${TARGET_METAFIELD}"]`;
  const STYLE_ID = "size-chart-units-style";

  const hasLetters = (s) => /[a-zA-Z]/.test(s);

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .size-chart-units {
        margin: 0.75rem 0;
      }
      .size-chart-units__toggle {
        display: inline-flex;
        align-items: center;
        gap: var(--spacing_thin);
        margin: 0 0 var(--spacing_narrow);
        line-height: 1;
      }
      .size-chart-units__btn {
        background: transparent;
        border: 0;
        padding: 0;
        cursor: pointer;
        font: inherit;
        text-decoration: none
      }
      .size-chart-units__btn[aria-pressed="true"] {
        text-decoration: underline;
        text-underline-offset: var(--text-underline-offset)
      }
    `;
    document.head.appendChild(style);
  }

  function round1(n) {
    const r = Math.round((n + Number.EPSILON) * 10) / 10;
    // trim trailing .0
    return (Math.abs(r - Math.round(r)) < 1e-10) ? String(Math.round(r)) : String(r);
  }

  function convertNumbersCmToIn(text) {
    // If there are letters (other than unit hints), skip.
    const cleanedForCheck = text.replace(/cm|inches|inch|\bin\b|"/gi, "").trim();
    if (hasLetters(cleanedForCheck)) return text;

    // Remove unit tokens before converting; keep punctuation/ranges.
    let t = text.replace(/cm/gi, "").replace(/inches/gi, "").replace(/inch/gi, "").replace(/\bin\b/gi, "").replace(/"/g, "");
    t = t.trim();

    // Replace every number in the string.
    return t.replace(/(\d+(?:\.\d+)?)/g, (m) => {
      const num = Number(m);
      if (!Number.isFinite(num)) return m;
      return round1(num / 2.54);
    });
  }

  function stripDuplicateIds(root) {
    root.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
  }

  function buildInchesTableFromCm(cmTable) {
    const inchesTable = cmTable.cloneNode(true);
    stripDuplicateIds(inchesTable);

    inchesTable.querySelectorAll("tr").forEach((row) => {
      const cells = Array.from(row.children).filter((el) => el.matches("th, td"));
      cells.forEach((cell, idx) => {
        // Skip first column (typically size labels like 26W)
        if (idx === 0) return;

        const original = (cell.textContent || "").trim();
        if (!original) return;

        const converted = convertNumbersCmToIn(original);
        if (converted !== original) cell.textContent = converted;
      });
    });

    inchesTable.dataset.unit = "in";
    inchesTable.hidden = true;
    return inchesTable;
  }

 function makeToggle(initialUnit = "cm") {
  const toggle = document.createElement("div");
  toggle.className = "size-chart-units__toggle";

  const btnCm = document.createElement("button");
  btnCm.type = "button";
  btnCm.className = "size-chart-units__btn link";
  btnCm.dataset.unit = "cm";
  btnCm.setAttribute("aria-pressed", initialUnit === "cm" ? "true" : "false");
  btnCm.textContent = "CM";

  const btnIn = document.createElement("button");
  btnIn.type = "button";
  btnIn.className = "size-chart-units__btn link";
  btnIn.dataset.unit = "in";
  btnIn.setAttribute("aria-pressed", initialUnit === "in" ? "true" : "false");
  btnIn.textContent = "IN";

  toggle.appendChild(btnCm);
  toggle.appendChild(btnIn);

  return toggle;
}

  function setUnit(wrapper, unit) {
    const cmTable = wrapper.querySelector('table[data-unit="cm"]');
    const inTable = wrapper.querySelector('table[data-unit="in"]');
    if (!cmTable || !inTable) return;

    cmTable.hidden = unit !== "cm";
    inTable.hidden = unit !== "in";

    wrapper.querySelectorAll(".size-chart-units__btn").forEach((btn) => {
      btn.setAttribute("aria-pressed", btn.dataset.unit === unit ? "true" : "false");
    });
  }

  function initSizeChartTable(table) {
    if (!table || table.closest('[data-size-chart-units-initialized="true"]')) return;

    // Wrap only the table so the toggle sits directly above it
    const wrapper = document.createElement("div");
    wrapper.className = "size-chart-units";
    wrapper.dataset.sizeChartUnitsInitialized = "true";

    const parent = table.parentNode;
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);

    // Mark original as CM table
    table.dataset.unit = "cm";

    // Build IN table
    const inchesTable = buildInchesTableFromCm(table);
    wrapper.appendChild(inchesTable);

    // Add toggle above the tables
    const toggle = makeToggle("cm");
    wrapper.insertBefore(toggle, table);

    toggle.addEventListener("click", (e) => {
      const btn = e.target.closest(".size-chart-units__btn");
      if (!btn) return;
      setUnit(wrapper, btn.dataset.unit);
    });

    // Default to CM
    setUnit(wrapper, "cm");
  }

  function initModal(modal) {
    // Convert every table in the size_chart modal content (usually just one)
    modal.querySelectorAll(".product-popup-modal__content-info table").forEach(initSizeChartTable);
  }

  function initAll() {
    injectStyles();
    document.querySelectorAll(MODAL_SELECTOR).forEach(initModal);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Theme editor resilience
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
})();
